module.exports = __webpack_public_path__ + "static/media/related-cases5.9b48602b.jpg";